
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 15.013c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3zm0-4.5c-.827 0-1.5.673-1.5 1.5s.673 1.5 1.5 1.5 1.5-.673 1.5-1.5-.673-1.5-1.5-1.5zM12 9.013c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3zm0-4.5c-.827 0-1.5.673-1.5 1.5s.673 1.5 1.5 1.5 1.5-.673 1.5-1.5-.673-1.5-1.5-1.5zM12 21.013c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3zm0-4.5c-.827 0-1.5.673-1.5 1.5s.673 1.5 1.5 1.5 1.5-.673 1.5-1.5-.673-1.5-1.5-1.5z"}}),_c('path',{attrs:{"d":"M8.75 24.013A2.754 2.754 0 016 21.263v-.599l-3.731-2.487A1.722 1.722 0 011.5 16.74a1.73 1.73 0 011.727-1.727H6v-.349l-3.731-2.487A1.722 1.722 0 011.5 10.74a1.73 1.73 0 011.727-1.727H6v-.349L2.269 6.177A1.722 1.722 0 011.5 4.74a1.73 1.73 0 011.727-1.727H6v-.25A2.754 2.754 0 018.75.013h6.5A2.754 2.754 0 0118 2.763v.25h2.773A1.73 1.73 0 0122.5 4.74c0 .579-.288 1.117-.77 1.438L18 8.664v.349h2.773A1.73 1.73 0 0122.5 10.74c0 .579-.288 1.117-.77 1.438L18 14.664v.349h2.773a1.728 1.728 0 01.957 3.164L18 20.664v.599a2.754 2.754 0 01-2.75 2.75h-6.5zm0-22.5c-.689 0-1.25.561-1.25 1.25v18.5c0 .689.561 1.25 1.25 1.25h6.5c.689 0 1.25-.561 1.25-1.25v-18.5c0-.689-.561-1.25-1.25-1.25h-6.5zm-5.523 15a.227.227 0 00-.126.416L6 18.862v-2.349H3.227zM18 18.862l2.899-1.933a.227.227 0 00-.126-.416H18v2.349zm0-6l2.899-1.933a.227.227 0 00-.126-.416H18v2.349zM3.227 10.513a.222.222 0 00-.161.067.227.227 0 00.035.349L6 12.862v-2.349H3.227zM18 6.862l2.899-1.933a.227.227 0 00-.126-.416H18v2.349zM3.227 4.513a.222.222 0 00-.161.067.227.227 0 00.035.349L6 6.862V4.513H3.227z"}})])
          )
        }
      }
    